import React from 'react';
import PropTypes from 'prop-types';
import { ThermoboxReportForm } from '../thermobox-report-form';
import { SimpleTableComponent } from '../../../../components/simple-table';
import { THERMOBOX_REPORT_TABLE_COLUMNS_NAMES } from '../../constants';

export const ThermoboxReportModalContent = ({ isLoading, thermoboxReportInfo, isThermoboxReportFormOpen }) => {
	if (isThermoboxReportFormOpen) {
		return <ThermoboxReportForm isLoading={isLoading} />;
	}

	return (
		<SimpleTableComponent
			rows={thermoboxReportInfo}
			isTableDataLoading={isLoading}
			columns={THERMOBOX_REPORT_TABLE_COLUMNS_NAMES}
			withOutMinHeight
		/>
	);
};

ThermoboxReportModalContent.propTypes = {
	isLoading: PropTypes.bool.isRequired,
	thermoboxReportInfo: PropTypes.arrayOf(
		PropTypes.shape({
			id: PropTypes.string.isRequired,
			title: PropTypes.string.isRequired,
			value: PropTypes.oneOfType([
				PropTypes.string,
				PropTypes.shape({
					name: PropTypes.string,
					role: PropTypes.string,
				}),
				PropTypes.shape({
					length: PropTypes.string,
					width: PropTypes.string,
					height: PropTypes.string,
				}),
			]).isRequired,
		}),
	),
	isThermoboxReportFormOpen: PropTypes.bool.isRequired,
};
